import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { AutoFocusDirective } from './directives/auto-focus.directive';
import { HasRoleDirective } from './directives/has-role.directive';

@NgModule({
  declarations: [
    AutoFocusDirective,
    HasRoleDirective,
  ],
  imports: [
    CommonModule
  ],
  exports:[HasRoleDirective, AutoFocusDirective]
})
export class CoreModule { }
